import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { mask, unMask } from 'remask';

export default function CardImportacao(props) {

    const [importacoes, setImportacoes] = useState({});
    // const [modalIsOpen, setModalIsOpen] = useState(false);
    const [parametros, setParametros] = useState([]);
    // const [atualizando, setAtualizando] = useState(false);
    const [dtLcto, setDtLcto] = useState('');
    const [dtIni, setDtIni] = useState('');
    const [dtFim, setDtFim] = useState('');
    // const [anual, setAnual] = useState(false);
    const [erro, setErro] = useState('');
    // const [filtros, setFiltros] = useState('');
    const [paramString, setParamString] = useState('');


    useEffect(() => {
        setImportacoes(props.importacoes);
    }, [props])

    // function handleImport(descricao, params) {
    //     var imps = Object.assign([], importacoes);
    //     var imp = imps.find(importacao => importacao.descricao === descricao);
    //     imp.importadores_status[0].status = 0;
    //     setImportacoes(imps);
    //     axios.get(`${process.env.REACT_APP_DELPHI_URL}/import?${params}`);
    //     console.log('aeho', `${process.env.REACT_APP_DELPHI_URL}/import?${params}`);
    // }

    function handleMaskDtLcto(value) {
        const originalValue = unMask(value);
        const maskedValue = mask(originalValue, [
            "9", "99", "99/9", "99/99", "99/99/9", "99/99/99", "99/99/999", "99/99/9999",
        ]);
        setDtLcto(maskedValue);
    }

    function handleMaskDtIni(value) {
        const originalValue = unMask(value);
        const maskedValue = mask(originalValue, [
            "9", "99", "99/9", "99/99", "99/99/9", "99/99/99", "99/99/999", "99/99/9999",
        ]);
        setDtIni(maskedValue);
    }

    function handleMaskDtFim(value) {
        const originalValue = unMask(value);
        const maskedValue = mask(originalValue, [
            "9", "99", "99/9", "99/99", "99/99/9", "99/99/99", "99/99/999", "99/99/9999",
        ]);
        setDtFim(maskedValue);
    }

    function renderParams() {
        return (
            <>
                {parametros.map((parametro) => {
                    if (parametro.tipo === 0) {
                        return (
                            <label>
                                <input type="checkbox"
                                // defaultChecked={checked}
                                // onChange={() => setChecked(!checked)}
                                />
                                &nbsp;
                                {parametro.descricao} <b className='red'> {(parametro.obrigatorio === 1 ? '*' : '')} </b>
                            </label>

                        )
                    }

                    if (parametro.tipo === 1) {
                        return (
                            <div className="column-data">
                                <label>{parametro.descricao} <b className='red'> {(parametro.obrigatorio === 1 ? '*' : '')} </b></label>
                                <input
                                    type="text"
                                    id="data"
                                    // ref={dataRef}
                                    value={dtLcto}
                                    className="form-control edit"
                                    // onKeyDown={(e) => handledown(e, osRef)}
                                    onChange={(e) => handleMaskDtLcto(e.target.value)}
                                />
                            </div>
                        )
                    }

                    if (parametro.tipo === 2) {
                        return (
                            <div className="column-data">
                                <label>{parametro.descricao} <b className='red'> {(parametro.obrigatorio === 1 ? '*' : '')} </b></label>
                                <input
                                    type="text"
                                    id="data"
                                    // ref={dataRef}
                                    value={dtIni}
                                    className="form-control edit"
                                    // onKeyDown={(e) => handledown(e, osRef)}
                                    onChange={(e) => handleMaskDtIni(e.target.value)}
                                />
                            </div>
                        )
                    }

                    if (parametro.tipo === 3) {
                        return (
                            <div className="column-data">
                                <label>{parametro.descricao} <b className='red'> {(parametro.obrigatorio === 1 ? '*' : '')} </b></label>
                                <input
                                    type="text"
                                    id="data"
                                    // ref={dataRef}
                                    value={dtFim}
                                    className="form-control edit"
                                    // onKeyDown={(e) => handledown(e, osRef)}
                                    onChange={(e) => handleMaskDtFim(e.target.value)}
                                />
                            </div>
                        )
                    }

                    if (parametro.tipo === 4) {
                        return (
                            <div className="column-data">
                                <label>{parametro.descricao} <b className='red'> {(parametro.obrigatorio === 1 ? '*' : '')} </b></label>
                                <input
                                    type="text"
                                    id="data"
                                    // ref={dataRef}
                                    value={paramString}
                                    className="form-control edit"
                                    // onKeyDown={(e) => handledown(e, osRef)}
                                    onChange={(e) => setParamString(e.target.value)}
                                />
                            </div>
                        )
                    }

                    return (<></>)

                })}
            </>
        )
    }

    function handleSetParametros(importador) {
        setParametros(importador.importadores_parametros);
    }

    function renderAtualizando() {
        // if (atualizando) {
        //     return (
        //         <div className='spinner'></div>
        //     )
        // }

    }

    function clickAtualizar(uri) {
        console.log(uri);
    }


    function renderNovo(importador) {

        return (
            <>
                <div className="botao">
                    <a href="#abrirModal" className="btn btn-success" onClick={() => handleSetParametros(importador)}>INICIAR</a>
                </div>
                <div id="abrirModal" className="modald border">
                    <a href="#fechar" className="fechar" >x</a>
                    <b>ATUALIZAR {importador.descricao}</b>
                    <hr></hr>
                    <div className="form modal-insumos">
                        {renderParams()}
                        <div className="column-descricao">
                            <a href="#fechar" className="btn btn-success espaco m-top" onClick={() => clickAtualizar(importador)}>
                                ATUALIZAR &nbsp;
                                {renderAtualizando()}
                            </a>
                        </div>
                    </div>
                </div>

            </>
        )

    }

    function renderspin() {
        return (
            <div className='spinner'></div>
        )
    }

    function renderstatus(importacao) {

        if (importacao.importadores_status[0].status === 0) {
            return (
                <div className="Footer">
                    <div className="context">
                        Status: Aguardando
                    </div>
                    <div className="body-spinner">
                        {renderspin()}
                    </div>
                </div>
            )
        } else if (importacao.importadores_status[0].status === 6) {
            return (
                <div className="Footer">
                    <div className="context">
                        Status: Excluindo
                    </div>
                    <div className="body-spinner">
                        {renderspin()}
                    </div>
                </div>
            )
        } else if (importacao.importadores_status[0].status === 1) {
            return (
                <div className="Footer">
                    <div className="context">
                        Status: Erro
                    </div>
                    {renderNovo(importacao)}
                    <div className="mostrar">
                        <div className="botao">
                            <a href="#abrirModalErro" className="btn btn-danger mostrar" onClick={() => setErro(importacao.importadores_status[0].erro)}>EXIBIR</a>

                        </div>

                        <div id="abrirModalErro" className="modald border">
                            <a href="#fechar" className="fechar" >x</a>
                            <b>ERRO</b>
                            <hr></hr>
                            <div className="form modal-insumos">
                                <p>
                                    {erro}
                                </p>
                            </div>
                        </div>
                    </div>

                </div>
            )
        } else if (importacao.importadores_status[0].status === 2) {
            return (
                <div className="Footer">
                    <div className="context">
                        Status: Baixando
                    </div>
                    <div className="context">
                        Servidor: {importacao.importadores_status[0].servidor}
                    </div>
                    <div className="body-spinner">
                        {renderspin()}
                    </div>
                </div>
            )
        } else if (importacao.importadores_status[0].status === 3) {
            return (
                <div className="Footer">
                    <div className="context">
                        Status: Inserindo
                    </div>
                    <div className="context">
                        Servidor: {importacao.importadores_status[0].servidor}
                    </div>
                    <div className="body-spinner">
                        {renderspin()}
                    </div>
                </div>
            )
        } else if (importacao.importadores_status[0].status === 4) {
            return (
                <div className="Footer">
                    <div className="context">
                        Status: Sincronizando
                    </div>
                    <div className="body-spinner">
                        {renderspin()}
                    </div>
                </div>
            )
        } else if (importacao.importadores_status[0].status === 5) {
            return (
                <div className="Footer">
                    <div className="context">
                        Status: Concluido
                    </div>
                    {renderNovo(importacao)}
                </div>
            )
        }
    }

    function rendercards() {
        
        if (importacoes.length > 0) {
            return (
                importacoes.map((importacao) => {
                    if (importacao) {
                        // console.log('data hora',importacao.importadores_status[0].updatedAt, new Date(importacao.importadores_status[0].updatedAt))
                        return (
                            <div className="card-import">
                                <div className="containder-title Content">
                                    {importacao.descricao}
                                </div>
                                {renderstatus(importacao)}
                                <div className="horas">
                                    Atualizado em: {moment(importacao.importadores_status[0].updatedAt).utc().format('DD/MM/YYYY HH:mm:ss')}
                                </div>
                            </div>
                        )
                    } else {
                        return (<></>)
                    }

                })
            )
        } else {
            return (
                <div></div>
            )
        }

    }

    return (
        <div className="content conteinercards">
            {rendercards()}
        </div>

    )
}
